import { config } from '@services/config';
import { QuoteDiffRequestParams, QuoteDiffResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { quoteQueryKey } from './keys';

export const useQuoteDiff = ({
  quoteIdSource,
  quoteIdTarget,
  enabled,
}: QuoteDiffRequestParams & { enabled?: boolean }) => {
  const client = useClient();
  const result = useQuery<QuoteDiffResponse, Error>({
    queryKey: quoteQueryKey.diff(quoteIdTarget),
    queryFn: async () => {
      const response = await client.get(`quote/${quoteIdSource}/diff/${quoteIdTarget}`).json<QuoteDiffResponse>();
      return response;
    },
    enabled: Boolean(quoteIdSource) && Boolean(quoteIdTarget) && enabled,
    ...config,
  });
  return { ...result, quoteDiff: result.data };
};
